import { TUTOR_TEACH_TYPE_ID } from '@/types'

export const tutorTeachTypes = (ids: TUTOR_TEACH_TYPE_ID[]) => {
  return {
    Class: ids.includes(TUTOR_TEACH_TYPE_ID.CLASS),
    OneToOne: ids.includes(TUTOR_TEACH_TYPE_ID.ONE_TO_ONE),
    Career: ids.includes(TUTOR_TEACH_TYPE_ID.CAREER)
  }
}
